import { Component } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

@Component({
    selector: 'app-placeholder',
    imports: [...COMMON_IMPORTS],
    template: `<div class="p-5 text-center text-2xl font-bold">
    Placeholder Works!
  </div>`
})
export class PlaceholderComponent {}
